export const ObtenerCatalogo = "ObtenerCatalogo";
export const Cargando = "CATALOGO_CARGANDO";
export const Error = "CATALOGO_ERROR";
